import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Loading from '../components/Loading';

export default function PickAvatar() {
  const navigate = useNavigate();
  const [avatars, setAvatars] = useState([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    Promise.all([api.avatars.list(), api.profile.getMe()])
      .then(([avatarRes, profileRes]) => {
        if (!mounted) return;
        setAvatars(avatarRes.data?.data?.avatars || []);
        setSelected(profileRes.data?.data?.profile?.avatarId || 'male_01');
      })
      .catch((err) => {
        if (mounted) setError(err.response?.data?.message || 'Unable to load avatars.');
      })
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  const save = async () => {
    if (!selected || saving) return;
    setSaving(true);
    setError('');
    try {
      await api.user.updateAvatar(selected);
      navigate('/profile', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save avatar.');
      setSaving(false);
    }
  };

  if (loading) return <Loading variant="section" label="" />;

  return (
    <div style={page}>
      <div style={header}>
        <button type="button" onClick={() => navigate('/profile')} style={back}>← Profile</button>
        <div>
          <h1 style={title}>Pick An Avatar</h1>
          <p style={subtitle}>Choose your 9jaWin profile avatar.</p>
        </div>
      </div>

      {error && <div style={errorBox}>{error}</div>}

      <div style={grid}>
        {avatars.map((avatar) => {
          const active = avatar.id === selected;
          return (
            <button
              key={avatar.id}
              type="button"
              onClick={() => setSelected(avatar.id)}
              aria-label={avatar.label}
              aria-pressed={active}
              style={{ ...tile, ...(active ? activeTile : null) }}
            >
              <div style={imageWrap}>
                <img src={avatar.imageUrl} alt={avatar.label} loading="lazy" style={image} />
                {active && <span aria-hidden="true" style={check}>✓</span>}
              </div>
              <span style={label}>{avatar.label}</span>
            </button>
          );
        })}
      </div>

      <button type="button" disabled={!selected || saving} onClick={save} style={saveButton}>
        {saving ? 'Saving…' : 'Save Avatar'}
      </button>
    </div>
  );
}

const page = { maxWidth: 680, margin: '0 auto', padding: '18px 16px 40px', color: '#fff' };
const header = { display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 18 };
const back = { background: 'none', border: 0, color: '#ddd', fontWeight: 800, cursor: 'pointer', padding: '8px 0' };
const title = { margin: 0, fontSize: '1.55rem' };
const subtitle = { margin: '5px 0 0', color: '#777', fontSize: 13 };
const grid = { display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: 12 };
const tile = { position: 'relative', background: '#111', border: '1px solid #292929', borderRadius: 18, padding: 14, color: '#fff', cursor: 'pointer', textAlign: 'center' };
const activeTile = { border: '2px solid #f59e0b', padding: 13, background: '#17120a' };
const imageWrap = { position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' };
const image = { width: 'min(34vw,180px)', height: 'min(34vw,180px)', maxWidth: 180, maxHeight: 180, borderRadius: '50%', objectFit: 'cover', display: 'block' };
const check = { position: 'absolute', right: 'calc(50% - min(17vw,90px) + 4px)', bottom: 4, width: 30, height: 30, borderRadius: '50%', display: 'grid', placeItems: 'center', background: '#f59e0b', color: '#111', fontWeight: 1000, border: '3px solid #111' };
const label = { display: 'block', marginTop: 9, color: '#ccc', fontSize: 12, fontWeight: 800 };
const saveButton = { width: '100%', marginTop: 18, padding: 14, border: 0, borderRadius: 12, background: '#f59e0b', color: '#111', fontWeight: 950, cursor: 'pointer' };
const errorBox = { background: 'rgba(239,68,68,.12)', color: '#fca5a5', border: '1px solid rgba(239,68,68,.35)', borderRadius: 10, padding: 12, marginBottom: 12 };
